import Freebets from './Freebets';

export default Freebets;
